namespace Matrix.Dashboards {
    export interface DatasetListParametersRequest extends Serenity.ServiceRequest {
        DatasetCode?: string;
    }
}
